import { render } from "./IconTrekTireSizeMax.vue?vue&type=template&id=2cf6662b"
import script from "./IconTrekTireSizeMax.vue?vue&type=script&lang=js"
export * from "./IconTrekTireSizeMax.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__